<div class="glass-sidebar text-white flex flex-col h-full transition-all duration-300 ease-in-out z-10" [ngClass]="isCollapsed ? 'w-16' : 'w-64'">
  <!-- Sidebar Header -->
  <div class="h-16 flex items-center p-4 border-b border-white/10" [ngClass]="isCollapsed ? 'justify-center' : 'justify-start'">
    <div class="flex items-center gap-3">
      <div class="logo-icon w-9 h-9 rounded-xl flex items-center justify-center shrink-0">
        <span class="font-bold text-sm text-white">MES</span>
      </div>
      @if (!isCollapsed) {
        <h2 class="text-lg font-semibold text-text-primary tracking-wide">MBLE-MES</h2>
      }
    </div>
  </div>

  <!-- Section Label -->
  @if (!isCollapsed) {
    <div class="px-4 pt-5 pb-2">
      <span class="text-xs font-medium text-text-muted/60 uppercase tracking-wider">Seiten</span>
    </div>
  }

  <!-- Navigation Menu -->
  <nav class="flex-1 py-2 overflow-y-auto scrollbar-thin" [ngClass]="isCollapsed ? 'pt-4' : ''">
    <ul class="space-y-1" [ngClass]="isCollapsed ? 'px-2' : 'px-3'">
      @for (item of menuItems; track item) {
        @if (canSee(item)) {
          <li>
            @if (item.children) {
              <!-- Parent menu item with children -->
              <div
                (click)="toggleSubmenu(item)"
                class="sidebar-link relative flex items-center rounded-xl text-text-muted hover:text-white hover:bg-white/10 transition-all duration-200 cursor-pointer"
                [ngClass]="isCollapsed ? 'justify-center p-3' : 'gap-3 px-3 py-2.5'"
              >
                <span class="material-icons shrink-0 text-xl">{{ item.icon }}</span>
                @if (!isCollapsed) {
                  <span class="text-sm font-medium flex-1">{{ item.label }}</span>
                  <span class="material-icons text-lg transition-transform duration-200" [ngClass]="item.expanded ? 'rotate-180' : ''"
                    >expand_more</span
                  >
                }
              </div>

              <!-- Submenu items -->
              @if (item.expanded && !isCollapsed) {
                <ul class="mt-1 ml-6 space-y-1">
                  @for (child of item.children; track child) {
                    @if (canSee(child)) {
                      <li>
                        <a
                          [routerLink]="child.route"
                          routerLinkActive="active-link"
                          class="sidebar-link relative flex items-center rounded-xl text-text-muted hover:text-white hover:bg-white/10 transition-all duration-200 gap-3 px-3 py-2"
                        >
                          <span class="material-icons shrink-0 text-lg">{{ child.icon }}</span>
                          <span class="text-sm font-medium">{{ child.label }}</span>
                        </a>
                      </li>
                    }
                  }
                </ul>
              }
            } @else {
              <!-- Regular menu item without children -->
              <a
                [routerLink]="item.route"
                routerLinkActive="active-link"
                class="sidebar-link relative flex items-center rounded-xl text-text-muted hover:text-white hover:bg-white/10 transition-all duration-200"
                [ngClass]="isCollapsed ? 'justify-center p-3' : 'gap-3 px-3 py-2.5'"
              >
                <span class="material-icons shrink-0 text-xl">{{ item.icon }}</span>
                @if (!isCollapsed) {
                  <span class="text-sm font-medium">{{ item.label }}</span>
                }
              </a>
            }
          </li>
        }
      }
    </ul>
  </nav>

  <!-- Sidebar Footer -->
  <div class="min-h-20 p-4 border-t border-white/10" [ngClass]="isCollapsed ? 'flex items-center justify-center' : ''">
    <div class="flex items-center" [ngClass]="isCollapsed ? 'justify-center' : 'gap-3'">
      <div class="user-avatar w-10 h-10 rounded-full flex items-center justify-center">
        <span class="font-semibold text-white" [ngClass]="isCollapsed ? 'text-xs' : 'text-sm'">
          {{ currentUser?.firstname?.charAt(0) }}{{ currentUser?.lastname?.charAt(0) }}
        </span>
      </div>
      @if (!isCollapsed) {
        <div class="flex flex-col flex-1">
          <span class="text-sm font-medium text-text-primary">{{ currentUser?.firstname }} {{ currentUser?.lastname }}</span>
          <a (click)="logout()" class="text-xs text-text-muted hover:text-primary-light transition-colors cursor-pointer">Logout</a>
        </div>
      }
    </div>
  </div>
</div>
